export const DEFAULT_CHANGE_DEBOUNCE_MS = 300;

export const FOCUSABLE_INPUTS = [
  "text",
  "textarea",
  "number",
  "email",
  "password",
  "search",
  "tel",
  "url",
  "date",
  "time",
  "datetime-local",
  "color",
  "range",
];
